import React, { useContext } from "react";
import { AboutList } from "../../data/Lists";
import { Container, Row, Col } from "react-bootstrap";
import "../../styles/main.css";
import "../../styles/Aboutcards.css";
import TEXT from "../../data/text";
import { LanguageContext } from "../../App";

export const About = () => {
  const { language } = useContext(LanguageContext);
  return (
    <div id="join_title">
      <Container fluid className="about1 text-center ">
        <Row className="mb-3">
          <Col lg={12}>
            <div
              // className="aos-init aos-animate"
              data-aos="fade-up"
              // data-aos-delay="0"
              data-aos-duration="800"
            >
              <h1 className="banner-main-heading">
                {TEXT[language]["ABOUT"]["0"]}
              </h1>
            </div>
          </Col>
        </Row>
      </Container>
      <Features />
    </div>
  );
};

export const About2 = () => {
  const { language } = useContext(LanguageContext);
  return (
    <div id="about_content">
      <Container className="about2 padding">
        <Row className="text-center mb-3">
          <Col xs={12}>
            <div
              // className="aos-init aos-animate"
              data-aos="fade-up"
              // data-aos-delay="0"
              data-aos-duration="1000"
            >
              <h1 className="banner-main-heading">
                {TEXT[language]["ABOUT"]["1"]}
              </h1>
              <p className="banner-heading2 sus-desc">
                {TEXT[language]["ABOUT"]["2"]}
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const Features = () => {
  const { language } = useContext(LanguageContext);
  return (
    <div className="about_cards_section">
      <div className="et_pb_section about_section et_section_regular">
        <div className="container">
          <div
            className="row"
            style={{
              justifyContent: "center",
              // alignContent:'center'
            }}
            //  className="row1 about_card_row et_pb_row_4col"
          >
            {AboutList[language].map((d, index) => {
              return (
                <div
                  key={index}
                  data-aos="zoom-in-up"
                  data-aos-delay="0"
                  data-aos-duration="1000"
                  className="col-xl-3 col-lg-3 col-md-6 col-sm-12 about_column text-center"
                  // className="column1 et_pb_column_1_4 et_pb_column_2  et_pb_css_mix_blend_mode_passthrough"
                >
                  <div
                    className="module about_card about_card_0 text_align_center et_pb_blurb_position_top  et_had_animation"
                    style={{}}
                  >
                    <div className="et_pb_blurb_content">
                      <div className="et_pb_main_blurb_image">
                        <span className="et_pb_image_wrap">
                          <span className="et-waypoint et_pb_animation_top et-pb-icon et-animated">
                            <img
                              alt="abt-icon"
                              width="100"
                              height="250"
                              src={d.img}
                            />
                          </span>
                        </span>
                      </div>
                      <div className="et_pb_blurb_container">
                        <h4 className="et_pb_module_header">
                          <span>{d.Title}</span>
                        </h4>
                        <div className="et_pb_blurb_description">
                          <p>{d.Desc}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
